import * as React from "react";
import { Resources, useResource } from "Translations/Resources";
import { useDispatch, useSelector } from "react-redux";
import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { CookieNames } from "Components/Models/CookieNames";
import { RootStateType } from "State/Store";
import { SettingsSubMenu } from "Components/Settings/SettingsSubMenu";
import { AccessRightCodes } from "Components/Models/AccessRights";
import {
  InvoiceItemCategoryDto,
  GetInvoiceItemCategoriesListQuery,
} from "Api/Api";
import { InvoiceItemCategoriesTable } from "Components/Settings/InvoiceItemCategories/InvoiceItemCategoriesTable";
import { getInvoiceItemCategoriesAsync } from "State/InvoiceItemCategories/InvoiceItemCategoriesReducer";
import { useTableFiltration } from "Hooks/Tables/useTableFiltration";

export const InvoiceItemCategoriesPage: React.FunctionComponent = _ => {
  const { t } = useResource();
  const { isLoading, list } = useSelector(
    (e: RootStateType) => e.invoiceItemCategories,
  );

  const dispatch = useDispatch();
  const [filtration] = useTableFiltration<
    InvoiceItemCategoryDto,
    GetInvoiceItemCategoriesListQuery
  >({
    tableCode: CookieNames.InvoiceItemCategories,
    onDataLoad: filter => {
      dispatch(
        getInvoiceItemCategoriesAsync.request({
          ...filter.filter,
          orderBy: filter.orderBy,
          desc: filter.desc,
          limit: filter.rows,
          offset: filter.page * filter.rows,
        }),
      );
    },
    defaultOrderBy: "name",
    filters: [
      {
        propertyName: "filterName",
        defaultValue: "",
      },
      {
        propertyName: "filterIsCode",
        defaultValue: "",
      },
      {
        propertyName: "filterDivisionName",
        defaultValue: "",
      },
    ],
  });

  return (
    <AuthenticatedLayout
      title={t(Resources.Settings.Title)}
      create={{
        accessRightCodes: [AccessRightCodes.Core_InvoiceItemCategories_Edit],
        url: `/${t(Resources.Routes.InvoiceItemCategories)}/${t(
          Resources.Routes.InvoiceItemCategoryCreate,
        )}`,
        title: t(Resources.InvoiceItemCategories.Detail.BtnCreate),
      }}
      breadcrumbItems={[
        {
          name: t(Resources.InvoiceItemCategories.Breadcrumb.Title),
        },
      ]}
    >
      <SettingsSubMenu />

      <InvoiceItemCategoriesTable
        list={list}
        onPageChange={filtration.onPageChange}
        isLoading={isLoading}
        filter={filtration.getFilterProps()}
        orderBy={filtration.ordering}
        paginationParams={filtration.pagination}
      />
    </AuthenticatedLayout>
  );
};
